export const DOCS_BASE_PATH =
  "https://static.share.market/web/trade/docs";
export const ACC_OPENING_BANNER =
  "https://sharemarket.onelink.me/uMHZ/pqq3ae73";
